import { Controller } from 'react-hook-form';
import { FormField, SearchField } from '@/components/custom/erp';
import { khoHangSearchColumns, QUERY_KEYS } from '@/constants';
import type { KhoHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface WarehouseSelection {
  uuid: string;
  ma_kho: string;
  ten_kho: string;
}

interface WarehouseLocationFormProps {
  mode: FormMode;
  kho: WarehouseSelection | null;
  setKho: (kho: KhoHang) => void;
}

const WarehouseLocationForm: React.FC<WarehouseLocationFormProps> = ({ mode, kho, setKho }) => {
  const isDisabled = mode === 'view';

  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        {/* Mã kho */}
        <div className='flex items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã kho</Label>
          <div className='flex gap-2'>
            <SearchField<KhoHang>
              type='text'
              columnDisplay='ma_kho'
              searchEndpoint={`/${QUERY_KEYS.KHO_HANG}`}
              searchColumns={khoHangSearchColumns}
              dialogTitle='Danh mục kho hàng'
              displayRelatedField='ten_kho'
              relatedFieldValue={kho?.ten_kho || ''}
              value={kho?.ma_kho || ''}
              disabled={isDisabled}
              onRowSelection={setKho}
            />
          </div>
        </div>

        {/* Mã vị trí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Mã vị trí</Label>
          <FormField type='text' name='ma_vi_tri' className='w-[11.25rem]' disabled={isDisabled || mode === 'edit'} />
        </div>

        {/* Tên vị trí */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tên vị trí</Label>
          <FormField type='text' name='ten_vi_tri' className='w-96' disabled={isDisabled} />
        </div>

        {/* Tên khác */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Tên khác</Label>
          <FormField type='text' name='ten_vi_tri2' className='w-96' disabled={isDisabled} />
        </div>

        {/* Ghi chú */}
        <div className='flex items-start'>
          <Label className='w-40 min-w-40 pt-2'>Ghi chú</Label>
          <Controller
            name='ghi_chu'
            render={({ field }) => (
              <textarea
                {...field}
                disabled={isDisabled}
                rows={2}
                className='w-full rounded-md border-b border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'
              />
            )}
          />
        </div>

        {/* Trạng thái */}
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Trạng thái</Label>
          <FormField
            type='select'
            name='status'
            className='w-40'
            options={[
              { value: '1', label: '1. Còn sử dụng' },
              { value: '0', label: '0. Không sử dụng' }
            ]}
            disabled={isDisabled}
          />
        </div>
      </div>
    </div>
  );
};

export default WarehouseLocationForm;
